<template>

  <div>
    <div class="va-row">
      <div class="flex md12 xs12">

        <div class="form-group">
          <div class="input-group">
            <vuestic-date-picker
              id="simple-input"
              v-model="rawDate"
              dateFormat="YYYY-MM-DD"
              @on-change="onChangeInternal"
            ></vuestic-date-picker>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'date-cell',

  data: function () {
    return {
      rawDate: new Date(this.rowData.documentDate),
    }
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },

    name: {
      type: String
    },

    onChange: {
      type: Function,
      default: () => {
      }
    }
  },

  mounted: function () {
  },

  methods: {
    onChangeInternal: function (date) {
      this.onChange({
        type: 'date',
        name: this.name,
        value: date[0].getTime(),
        id: this.rowData.id
      })
    }
  }
}

</script>

<style scoped>

</style>
